var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 35C11.1344 35 10.3398 34.6845 9.67891 34.0535C9.01797 33.4225 8.6875 32.6639 8.6875 31.7778V10.8333H7V7.61111H14.5938L15.4375 6H25.5625L26.4062 7.61111H34V10.8333H32.3125V31.7778C32.3125 32.6639 31.982 33.4225 31.3211 34.0535C30.6602 34.6845 29.8656 35 28.9375 35H12.0625ZM28.9375 10.8333H12.0625V31.7778H28.9375V10.8333ZM15.4375 28.5556H18.8125V14.0556H15.4375V28.5556ZM22.1875 28.5556H25.5625V14.0556H22.1875V28.5556Z",
    fill: "currentColor"
  })));
};
export default SvgTrash;